export const grammarPatterns = [
  {
    questionNumber: 1,
    audioFile: "/audios/part1/grammar/sentence1.mp3",
    sentence: "Papers have been stacked on the desk.",
    question: "종이를 쌓아 올리는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 종이들이 책상 위에 쌓여져 있는 상태.",
  },
  {
    questionNumber: 2,
    audioFile: "/audios/part1/grammar/sentence2.mp3",
    sentence: "A laptop has been placed on the table.",
    question: "노트북을 놓는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 노트북이 테이블 위에 놓여져 있는 상태입니다.",
  },
  {
    questionNumber: 3,
    audioFile: "/audios/part1/grammar/sentence3.mp3",
    sentence: "The ladder has been placed against the wall.",
    question: "사다리가 벽에 놓여 있습니까?",
    answer: "있음",
    explanation:
      "벽에 기대서 놓여있는 사다리를 이미지에서 볼 수 있습니다. 이 외에 자전거 의자 등 다양한 사물이 나올 수 있습니다.",
  },
  {
    questionNumber: 4,
    audioFile: "/audios/part1/grammar/sentence4.mp3",
    sentence: "Books are arranged on the shelf.",
    question: "책장에 책들을 놓는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 책들이 책장에 정렬되어 있는 상태.",
  },
  {
    questionNumber: 5,
    audioFile: "/audios/part1/grammar/sentence5.mp3",
    sentence: "A telephone has been mounted on the wall.",
    question: "전화기를 설치하는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 전화기가 벽에 설치되어 있는 상태",
  },
  {
    questionNumber: 6,
    audioFile: "/audios/part1/grammar/sentence6.mp3",
    sentence: "The monitor is placed on the desk.",
    question: "모니터가 책상 위에 놓여 있습니까?",
    answer: "있음",
    explanation: "해석: 모니터가 책상 위에 놓여 있다.",
  },
  {
    questionNumber: 7,
    audioFile: "/audios/part1/grammar/sentence7.mp3",
    sentence: "Files have been stored in the cabinet.",
    question: "캐비닛에 파일들을 보관하는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 파일들이 캐비닛에 보관되어 있는 상태.",
  },
  {
    questionNumber: 8,
    audioFile: "/audios/part1/grammar/sentence8.mp3",
    sentence: "The documents have been spread across the table.",
    question: "테이블에 서류들을 펼쳐놓는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 서류들이 테이블에 펼쳐져 있다.",
  },
  {
    questionNumber: 9,
    audioFile: "/audios/part1/grammar/sentence9.mp3",
    sentence: "Water has been poured into the glass.",
    question: "물이 담긴 컵이 있습니까?",
    answer: "있음",
    explanation: "해석: 물이 컵에 따라져 있는 상태입니다.",
  },
  {
    questionNumber: 10,
    audioFile: "/audios/part1/grammar/sentence10.mp3",
    sentence: "The blinds have been shut.",
    question: "블라인드를 닫고 있는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 블라인드가 닫혀있는 상태.",
  },
  {
    questionNumber: 11,
    audioFile: "/audios/part1/grammar/sentence11.mp3",
    sentence: "Boxes are stacked in the corner.",
    question: "박스를 쌓는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 구석에 박스들이 쌓여 있는 상태.",
  },
  {
    questionNumber: 12,
    audioFile: "/audios/part1/grammar/sentence12.mp3",
    sentence: "A calendar has been hung on the wall.",
    question: "벽에 달력이 걸려 있습니까?",
    answer: "있음",
    explanation: "해석: 벽에 달력이 걸려 있다.",
  },
  {
    questionNumber: 13,
    audioFile: "/audios/part1/grammar/sentence13.mp3",
    sentence: "The lights are mounted on the ceiling.",
    question: "조명이 천장에 설치되어 있습니까?",
    answer: "있음",
    explanation: "해석: 천장에 조명이 설치되어 있다.",
  },
  {
    questionNumber: 14,
    audioFile: "/audios/part1/grammar/sentence14.mp3",
    sentence: "Coffee cups have been arranged on the shelf.",
    question: "선반에 커피잔들이 정렬되어 있습니까?",
    answer: "있음",
    explanation: "해석: 선반에 커피잔들이 정렬되어 있다.",
  },
  {
    questionNumber: 15,
    audioFile: "/audios/part1/grammar/sentence15.mp3",
    sentence: "The table is being installed.",
    question: "테이블을 설치하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 테이블이 '설치되고 있는 중'입니다. (설치 작업이 진행 중)",
  },
  {
    questionNumber: 16,
    audioFile: "/audios/part1/grammar/sentence16.mp3",
    sentence: "Documents are being sorted.",
    question: "서류들을 정리하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 서류들이 '정리되고 있는 중'입니다. (누군가 현재 정리 중)",
  },
  {
    questionNumber: 17,
    audioFile: "/audios/part1/grammar/sentence17.mp3",
    sentence: "The chairs are being arranged.",
    question: "의자들을 배치하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 의자들이 '배치되고 있는 중'입니다. (배치 작업 진행 중으로, 작업하는 사람이 있어야 함)",
  },
  {
    questionNumber: 18,
    audioFile: "/audios/part1/grammar/sentence18.mp3",
    sentence: "A picture is being hung on the wall.",
    question: "그림을 거는 사람이 있습니까?",
    answer: "있음",
    explanation: "해석: 그림이 '걸리고 있는 중'입니다. (누군가 현재 걸고 있음)",
  },
  {
    questionNumber: 19,
    audioFile: "/audios/part1/grammar/sentence19.mp3",
    sentence: "The floor is being cleaned.",
    question: "청소하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 바닥이 '청소되고 있는 중'입니다. (청소하는 사람이 나와야 함)",
  },
  {
    questionNumber: 20,
    audioFile: "/audios/part1/grammar/sentence20.mp3",
    sentence: "Books are being moved to new shelves.",
    question: "책들을 옮기는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 책들이 '옮겨지고 있는 중'입니다. (이동 작업하는 사람이 나올 것)",
  },
  {
    questionNumber: 21,
    audioFile: "/audios/part1/grammar/sentence21.mp3",
    sentence: "The computer is being repaired.",
    question: "컴퓨터를 수리하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 컴퓨터가 '수리되고 있는 중'입니다. (수리 작업 하는 사람이 이미지에 있음)",
  },
  {
    questionNumber: 22,
    audioFile: "/audios/part1/grammar/sentence22.mp3",
    sentence: "A document is being passed around the meeting room.",
    question: "회의실에 서류를 나눠주는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 문서가 '회의실에서 전달되고 있는 중'입니다. (회의실에서 문서가 사람들 사이에서 돌아가는 중)",
  },
  {
    questionNumber: 23,
    audioFile: "/audios/part1/grammar/sentence23.mp3",
    sentence: "The camera and lights are being set up.",
    question: "카메라와 조명이 설치되어 있습니까?",
    answer: "없음",
    explanation:
      "해석: 카메라와 조명이 '설치되고 있는 중'입니다. (설치 작업 진행 중인 사람이 나옴)",
  },
  {
    questionNumber: 24,
    audioFile: "/audios/part1/grammar/sentence24.mp3",
    sentence: "The chairs have been pushed under the table.",
    question: "의자들을 미는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 의자들이 '테이블 밑으로 밀려있는 상태'입니다. (이미 의자가 테이블 밑으로 들어가 있는 상태)",
  },
  {
    questionNumber: 25,
    audioFile: "/audios/part1/grammar/sentence25.mp3",
    sentence: "Flowers are being planted in the garden.",
    question: "정원에 꽃들을 심는 사람들이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 꽃들이 '심어지고 있는 중'입니다. (꽃을 심고 있는 사람이 이미지에 나옴)",
  },
  {
    questionNumber: 26,
    audioFile: "/audios/part1/grammar/sentence26.mp3",
    sentence: "The shelves have been stocked with fresh produce.",
    question: "선반에 농산물을 진열하는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 선반에 신선한 농산물이 '진열되어 있는 상태'입니다. (이미 진열이 완료된 상태)",
  },
  {
    questionNumber: 27,
    audioFile: "/audios/part1/grammar/sentence27.mp3",
    sentence: "The walls are being covered with wallpaper.",
    question: "도배 작업이 진행되고 있습니까?",
    answer: "있음",
    explanation:
      "해석: 벽에 '벽지가 발라지고 있는 중'입니다. (도배 작업이 진행 중)",
  },
  {
    questionNumber: 28,
    audioFile: "/audios/part1/grammar/sentence28.mp3",
    sentence: "The grass is being trimmed in the park.",
    question: "잔디를 깎고 있는 사람이 있습니까?",
    answer: "있음",
    explanation: "해석: 공원의 잔디가 '깎이고 있는 중'입니다.",
  },
  {
    questionNumber: 29,
    audioFile: "/audios/part1/grammar/sentence29.mp3",
    sentence: "The trees are growing along the road.",
    question: "나무들이 도로를 따라 있습니까?",
    answer: "있음",
    explanation:
      "해석: 나무들이 '도로를 따라 자라고 있는 중'입니다. (이미지에선 나무가 도로를 따라 있기만 하면 됨)",
  },
  {
    questionNumber: 30,
    audioFile: "/audios/part1/grammar/sentence30.mp3",
    sentence: "The road is being paved with asphalt.",
    question: "도로에 아스팔트를 까는 작업이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 도로에 '아스팔트가 깔리고 있는 중'입니다. (아스팔트 포장 작업 중인 사진이 나옴)",
  },
  {
    questionNumber: 31,
    audioFile: "/audios/part1/grammar/sentence31.mp3",
    sentence: "The wood floor is being waxed.",
    question: "나무 바닥에 왁스칠 하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 나무 바닥에 '왁스가 발라지고 있는 중'입니다. (현재 왁스 작업 진행 중)",
  },
  {
    questionNumber: 32,
    audioFile: "/audios/part1/grammar/sentence32.mp3",
    sentence: "The office supplies are being organized.",
    question: "사무용품을 정리하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 사무용품이 '정리되고 있는 중'입니다. (누군가 현재 정리 중)",
  },
  {
    questionNumber: 33,
    audioFile: "/audios/part1/grammar/sentence33.mp3",
    sentence: "The bed's side rail has been raised.",
    question: "침대 사이드레일을 올리는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 침대 사이드레일이 '올려진 상태'입니다. (이미 올려져 있는 상태)",
  },
  {
    questionNumber: 34,
    audioFile: "/audios/part1/grammar/sentence34.mp3",
    sentence: "The man is wearing glasses.",
    question: "안경을 착용하고 있는 중인 남자가 있습니까?",
    answer: "없음",
    explanation:
      "해석: 남자가 안경을 이미 쓴 상태로, 착용중이지 않습니다. (쓰는 중이라면 'is putting on glasses'가 되어야 합니다)",
  },
  {
    questionNumber: 35,
    audioFile: "/audios/part1/grammar/sentence35.mp3",
    sentence: "She is wearing a name tag.",
    question: "명찰을 달고 있는 여자가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 그녀가 명찰을 이미 착용한 상태입니다. (착용 중이라면 'is putting on a name tag'가 되어야 합니다)",
  },
  {
    questionNumber: 36,
    audioFile: "/audios/part1/grammar/sentence36.mp3",
    sentence: "A bicycle is being ridden down the street.",
    question: "자전거를 타고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 자전거가 '도로를 달리고 있는 중'입니다. (현재 진행형 수동태로, 누군가가 자전거를 타고 도로를 달리고 있는 상황입니다)",
  },
  {
    questionNumber: 37,
    audioFile: "/audios/part1/grammar/sentence37.mp3",
    sentence: "He is wearing a safety helmet.",
    question: "안전모를 착용하고 있는 중인 남자가 있습니까?",
    answer: "없음",
    explanation:
      "해석: 그가 안전모를 '이미 착용한 상태'입니다. (착용하는 중 이라면 'is putting on a safety helmet'이 되어야 합니다)",
  },
  {
    questionNumber: 38,
    audioFile: "/audios/part1/grammar/sentence38.mp3",
    sentence: "The presenter is wearing a microphone.",
    question: "마이크를 착용한 발표자가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 발표자가 마이크를 '착용한 상태'입니다. (착용하는 중이라면 'is putting on a microphone'이 되어야 합니다)",
  },
  {
    questionNumber: 39,
    audioFile: "/audios/part1/grammar/sentence39.mp3",
    sentence: "The wallpaper is being taken off the wall.",
    question: "도배 작업을 하는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 벽지가 '떼어내지고 있는 중'입니다. 일부가 벽에서 벗겨지고 있는 상태이거나 누군가 떼고 있는 중으로 도배는 아님",
  },
  {
    questionNumber: 40,
    audioFile: "/audios/part1/grammar/sentence40.mp3",
    sentence: "The worker is grasping a tool.",
    question: "남자의 손에 도구가 잡혀 있습니까?",
    answer: "있음",
    explanation:
      "해석: 작업자가 도구를 '잡고 있는 중'입니다. 현재 진행형으로 도구를 손에 쥐고 있는 상태를 나타냅니다.",
  },
  {
    questionNumber: 41,
    audioFile: "/audios/part1/grammar/sentence41.mp3",
    sentence: "The doctor is wearing a stethoscope.",
    question: "청진기를 착용한 의사가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 의사가 청진기를 이미 착용한 상태'입니다. (착용 중이라면 'is putting on a stethoscope around their neck'가 되어야 합니다)",
  },
  {
    questionNumber: 42,
    audioFile: "/audios/part1/grammar/sentence42.mp3",
    sentence: "The worker is wearing protective gloves.",
    question: "보호장갑을 착용한 작업자가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 작업자가 보호장갑을 '착용한 상태'입니다. (착용하는 중이라면 'is putting on protective gloves'가 되어야 합니다)",
  },
  {
    questionNumber: 43,
    audioFile: "/audios/part1/grammar/sentence43.mp3",
    sentence: "A lamp is hanging over the table.",
    question: "램프가 테이블 위에 있나요?",
    answer: "있음",
    explanation:
      "해석: 램프가 '테이블 위에 걸려있는 상태'입니다.그러나 데스크 램프처럼 책상 위에 놓여져 있는 것은 아님.",
  },
  {
    questionNumber: 44,
    audioFile: "/audios/part1/grammar/sentence44.mp3",
    sentence: "She is wearing a bracelet.",
    question: "그녀의 팔에 팔찌가 있습니까?",
    answer: "있음",
    explanation: "해석: 그녀가 팔찌를 '착용한 상태'입니다. ",
  },
  {
    questionNumber: 45,
    audioFile: "/audios/part1/grammar/sentence45.mp3",
    sentence: "The student is wearing a backpack.",
    question: "학생이 가방을 매고 있습니까?",
    answer: "있음",
    explanation: "해석: 학생이 백팩을 '멘 상태'입니다.",
  },
  {
    questionNumber: 46,
    audioFile: "/audios/part1/grammar/sentence46.mp3",
    sentence: "The bride is wearing a veil.",
    question: "베일을 쓴 신부가 있습니까?",
    answer: "있음",
    explanation: "해석: 신부가 베일을 '쓴 상태'입니다.",
  },
  {
    questionNumber: 47,
    audioFile: "/audios/part1/grammar/sentence47.mp3",
    sentence: "The woman is wearing a scarf around her neck.",
    question: "여자의 목에 스카프가 있습니까?",
    answer: "있음",
    explanation: "해석: 여자가 목에 스카프를 '두른 상태'입니다. ",
  },
  {
    questionNumber: 48,
    audioFile: "/audios/part1/grammar/sentence48.mp3",
    sentence: "He is wearing a belt around his waist.",
    question: "남자 허리에 벨트가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 그가 허리에 벨트를 '착용을 한 상태'입니다. (만약 착용 중이라면 'is putting on a belt'가 되어야 합니다)",
  },
  {
    questionNumber: 49,
    audioFile: "/audios/part1/grammar/sentence49.mp3",
    sentence: "The child is grasping a balloon.",
    question: "풍선을 잡은 아이가 있습니까?",
    answer: "있음",
    explanation:
      "해석: 아이가 풍선을 '움켜쥐고 있는 중'입니다. 이 문장에 맞는 이미지는 아이가 풍선을 손으로 꽉 잡고 있는 장면입니다.",
  },
  {
    questionNumber: 50,
    audioFile: "/audios/part1/grammar/sentence50.mp3",
    sentence: "The businessman is picking up a laptop.",
    question: "노트북을 들고 서있는 사업가가 있습니까?",
    answer: "없음",
    explanation:
      "해석: 이 문장에 맞는 이미지는 사업가가 책상에서 노트북을 집어드는 순간의 장면입니다.",
  },
  {
    questionNumber: 51,
    audioFile: "/audios/part1/grammar/sentence51.mp3",
    sentence: "The drawers have been left open.",
    question: "서랍을 열고 있는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 서랍이 '열려진 상태로 남겨져 있습니다'. 이 문장에 맞는 이미지는 서랍이 열려있는 정적인 장면입니다.",
  },
  {
    questionNumber: 52,
    audioFile: "/audios/part1/grammar/sentence52.mp3",
    sentence: "The man is taking a seat.",
    question: "의자에 앉아 있는 남자가 있습니까?",
    answer: "없음",
    explanation:
      "해석: 남자가 '앉는 중'입니다. 이 문장에 맞는 이미지는 남자가 의자에 막 앉으려는 순간의 장면입니다. (만약 이미 의자에 앉아있는 상태라면 'is sitting'이 되어야 합니다)",
  },
  {
    questionNumber: 53,
    audioFile: "/audios/part1/grammar/sentence53.mp3",
    sentence: "The signs are displayed at the entrance.",
    question: "표지판이 입구에 있습니까?",
    answer: "있음",
    explanation:
      "해석: 입구에 '표지판이 설치되어 있는 상태'입니다. 이 문장에 맞는 이미지는 입구에 표지판이 이미 설치되어 있는 정적인 장면입니다. ",
  },
  {
    questionNumber: 54,
    audioFile: "/audios/part1/grammar/sentence54.mp3",
    sentence: "The door has been closed.",
    question: "문이 닫혀있습니까?",
    answer: "있음",
    explanation:
      "해석: 문이 '닫혀있는 상태'입니다. 이미 문이 닫혀있는 상태를 나타냅니다.",
  },
  {
    questionNumber: 55,
    audioFile: "/audios/part1/grammar/sentence55.mp3",
    sentence: "A picture is hanging on the wall.",
    question: "벽에 그림을 거는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 벽에 그림이 걸려 있는 상태입니다. 이 문장에 맞는 이미지는 그림이 이미 벽에 걸려있는 정적인 장면입니다. (만약 지금 막 걸고 있는 중이라면 'is being hung on the wall'이 되어야 합니다)",
  },
  {
    questionNumber: 56,
    audioFile: "/audios/part1/grammar/sentence56.mp3",
    sentence: "The shelves are being stocked with fresh produce.",
    question: "선반에 농산물을 진열하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 선반에 신선한 농산물이 '진열되고 있는 중'입니다. (누군가 현재 진열 작업 중)",
  },
  {
    questionNumber: 57,
    audioFile: "/audios/part1/grammar/sentence57.mp3",
    sentence: "The walls are covered with wallpaper.",
    question: "벽에 벽지를 붙이는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 벽에 '벽지가 붙어 있는 상태'입니다. (이미 벽지 작업이 완료된 상태)",
  },
  {
    questionNumber: 58,
    audioFile: "/audios/part1/grammar/sentence58.mp3",
    sentence: "The chairs have been set up against the wall.",
    question: "의자를 벽에 놓는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 의자들이 '벽을 따라 배치되어 있는 상태'입니다. against= 닿아 있거나 가까이 있는 상태",
  },
  {
    questionNumber: 59,
    audioFile: "/audios/part1/grammar/sentence59.mp3",
    sentence: "Flowers are planted in the garden.",
    question: "꽃을 심는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 정원에 꽃들이 '심어져 있는 상태'입니다.",
  },
  {
    questionNumber: 60,
    audioFile: "/audios/part1/grammar/sentence60.mp3",
    sentence: "The furniture is being placed.",
    question: "가구를 놓는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 가구가 '놓여지고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 가구를 배치하고 있는 사진이 나옵니다..",
  },
  {
    questionNumber: 61,
    audioFile: "/audios/part1/grammar/sentence61.mp3",
    sentence: "The curtains are being hung.",
    question: "커튼을 걸고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 커튼이 '걸리고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 커튼을 창문에 설치하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 62,
    audioFile: "/audios/part1/grammar/sentence62.mp3",
    sentence: "The packages have been wrapped.",
    question: "소포를 포장하는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 소포가 '포장되어 있는 상태'입니다.",
  },
  {
    questionNumber: 63,
    audioFile: "/audios/part1/grammar/sentence63.mp3",
    sentence: "The furniture is being assembled.",
    question: "가구를 조립하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 가구가 '조립되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 가구 부품을 맞추어 조립하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 64,
    audioFile: "/audios/part1/grammar/sentence64.mp3",
    sentence: "The carpet is being laid.",
    question: "카펫을 깔고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 카펫이 '깔리고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 바닥에 카펫을 놓는 장면이 있어야 합니다",
  },
  {
    questionNumber: 65,
    audioFile: "/audios/part1/grammar/sentence65.mp3",
    sentence: "The paintings are being hung.",
    question: "그림을 거는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 그림이 '걸리고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 벽에 그림을 설치하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 66,
    audioFile: "/audios/part1/grammar/sentence66.mp3",
    sentence: "The windows are being cleaned.",
    question: "창문을 닦는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 창문이 '청소되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 창문을 닦고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 67,
    audioFile: "/audios/part1/grammar/sentence67.mp3",
    sentence: "The plants are being watered.",
    question: "식물에 물을 주는 사람이 있습니까?",
    answer: "있음",
    explanation: "해석: 식물에 '물이 주어지고 있는 중'입니다. ",
  },
  {
    questionNumber: 68,
    audioFile: "/audios/part1/grammar/sentence68.mp3",
    sentence: "The floor is being swept.",
    question: "바닥을 쓸고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 바닥이 '쓸리고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 빗자루로 바닥을 청소하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 69,
    audioFile: "/audios/part1/grammar/sentence69.mp3",
    sentence: "The light bulbs are being replaced.",
    question: "전구를 교체하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 전구가 '교체되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 전구를 새것으로 바꾸고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 70,
    audioFile: "/audios/part1/grammar/sentence70.mp3",
    sentence: "The walls are being painted.",
    question: "벽을 칠하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 벽이 '칠해지고 있는 중'입니다. 페인팅을 하는 사람이 이미지에 있습니다.",
  },
  {
    questionNumber: 71,
    audioFile: "/audios/part1/grammar/sentence71.mp3",
    sentence: "The grass has been trimmed in the park.",
    question: "잔디를 깎는 사람이 있나요?",
    answer: "없음",
    explanation:
      "해석: 공원의 잔디가 '깎여있는 상태'입니다. 이 문장에 맞는 이미지는 잔디가 이미 깔끔하게 정리되어 있는 장면입니다.",
  },
  {
    questionNumber: 72,
    audioFile: "/audios/part1/grammar/sentence72.mp3",
    sentence: "The equipment is being installed.",
    question: "장비를 설치하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 장비가 '설치되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 장비를 조립하거나 설치하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 73,
    audioFile: "/audios/part1/grammar/sentence73.mp3",
    sentence: "The documents are being distributed.",
    question: "서류를 배분하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 서류가 '배분되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 여러 사람에게 서류를 나누어주고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 74,
    audioFile: "/audios/part1/grammar/sentence74.mp3",
    sentence: "The desks are being dusted.",
    question: "책상을 닦는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 책상이 '먼지가 닦이고 있는 중'입니다. 이 문장에 맞는 이미지는 사람이 책상의 먼지를 닦거나 털고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 75,
    audioFile: "/audios/part1/grammar/sentence75.mp3",
    sentence: "The whiteboard is being erased.",
    question: "화이트보드를 지우는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 화이트보드가 '지워지고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 화이트보드의 내용을 지우고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 76,
    audioFile: "/audios/part1/grammar/sentence76.mp3",
    sentence: "The packages are being wrapped.",
    question: "소포를 포장하는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 소포가 '포장되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 물건을 포장지로 싸고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 77,
    audioFile: "/audios/part1/grammar/sentence77.mp3",
    sentence: "The cables are being organized.",
    question: "케이블을 정리하고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 케이블이 '정리되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 복잡하게 얽힌 케이블을 정돈하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 78,
    audioFile: "/audios/part1/grammar/sentence78.mp3",
    sentence: "The trash has been collected.",
    question: "쓰레기가 수거되어 있습니까?",
    answer: "있음",
    explanation: "해석: 쓰레기가 '수거된 상태'입니다.",
  },
  {
    questionNumber: 79,
    audioFile: "/audios/part1/grammar/sentence79.mp3",
    sentence: "The signs are being posted.",
    question: "안내문을 부착하고 있는 사람이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 안내문이 '부착되고 있는 중'입니다. 이 문장에 맞는 이미지는 누군가가 벽이나 게시판에 안내문을 붙이고 있어야만 하는 장면으로 이미지에 사람이 있어야 합니다.",
  },

  {
    questionNumber: 80,
    audioFile: "/audios/part1/grammar/sentence80.mp3",
    sentence: "A meeting is being held.",
    question: "회의하는 사람들이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 회의가 '진행되고 있는 중'입니다. 이 문장에 맞는 이미지는 사람들이 회의실에서 회의를 하고 있어야만 하는 장면입니다.",
  },
  {
    questionNumber: 81,
    audioFile: "/audios/part1/grammar/sentence81.mp3",
    sentence: "The books are placed on the shelf.",
    question: "책을 선반에 놓는 사람이 있습니까?",
    answer: "없음",
    explanation: "해석: 책이 '선반에 이미 놓여있는 상태'입니다.",
  },
  {
    questionNumber: 82,
    audioFile: "/audios/part1/grammar/sentence82.mp3",
    sentence: "Dining is taking place.",
    question: "식사를 하는 사람들이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 식사가 '진행되고 있는 중'입니다. 이 문장에 맞는 이미지는 사람들이 테이블에서 식사를 하는 장면입니다.",
  },
  {
    questionNumber: 83,
    audioFile: "/audios/part1/grammar/sentence83.mp3",
    sentence: "A meeting is in progress.",
    question: "회의하는 사람들이 있습니까?",
    answer: "있음",
    explanation:
      "해석: 회의실에서 회의가 '진행되고 있는 중'입니다. 즉 회의하는 사람이 있는 장면입니다.",
  },
  {
    questionNumber: 84,
    audioFile: "/audios/part1/grammar/sentence84.mp3",
    sentence: "A large mirror has been mounted against the wall.",
    question: "거울이 벽에 있습니까?",
    answer: "있음",
    explanation: "해석: 큰 거울이 '벽에 설치되어 있는 상태'입니다.",
  },
  {
    questionNumber: 85,
    audioFile: "/audios/part1/grammar/sentence85.mp3",
    sentence: "A light fixture is hanging from the ceiling.",
    question: "조명을 천장에 달고 있는 사람이 있습니까?",
    answer: "없음",
    explanation:
      "해석: 조명이 '천장에 달려있는 상태'입니다. 이 문장에 맞는 이미지는 조명이 이미 천장에 설치되어 있는 정적인 장면입니다.",
  },

  {
    questionNumber: 86,
    audioFile: "/audios/part1/grammar/sentence86.mp3",
    sentence: "The man is putting on a hat.",
    question: "모자를 착용한 남자가 있습니까?",
    answer: "없음",
    explanation:
      "해석: 남자가 '모자를 쓰고 있는 중'입니다. 이 문장에 맞는 이미지는 남자가 모자를 머리에 씌우고 있는 동작의 장면입니다. (만약 이미 쓴 상태라면 'is wearing a hat'이 되어야 합니다)",
  },
];

// 섞인 버전 추가
export const shuffledGrammarPatterns = [...grammarPatterns].sort(
  () => Math.random() - 0.5
);
